module.exports = __webpack_public_path__ + "static/foundation-small-img-c12e8941c5afded6431f8d465a892853.png";